import { render } from "./BlogPost.vue?vue&type=template&id=5b48e0d8&hidden=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jamesedgeworth/Sites/je-vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__